module.exports = __webpack_public_path__ + "assets/img/high_priority.2657f925.svg";